import React from 'react'
import PropTypes from 'prop-types'
import { uniq } from 'lodash'
import { Select } from './index'

const TOP_COUNTRIES = ['United States', 'Canada']

export default class CountrySelector extends React.Component {
  static propTypes = {
    countries: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    value: PropTypes.string.isRequired,
  }

  componentWillMount() {
    this.countryOptions = this._getOptions()
  }

  render() {
    const { value, onChange } = this.props
    return (
      <Select
        label="Country"
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
      >
        {this.countryOptions.map((country, idx) => (
          <option key={idx} value={country}>
            {country}
          </option>
        ))}
      </Select>
    )
  }

  _getOptions() {
    const { countries } = this.props
    // If no countries were provided
    if (!countries.length) return []

    // Add the top countries to the top of the list if they are present
    const countryOptions = []
    TOP_COUNTRIES.forEach((country) => {
      const countryIdx = countries.indexOf(country)
      if (countryIdx !== -1) {
        countryOptions.push(countries[countryIdx])
      }
    })

    // If the countries provided are the same as the top countries
    if (uniq(TOP_COUNTRIES.concat(countries)).length === TOP_COUNTRIES.length)
      return countryOptions

    return countryOptions.concat(countries)
  }
}
